//user actions
export const LIVE_STREAMING = 'LIVE_STREAMING';
export const SCHEDULE_INFO = 'SCHEDULE_INFO';
export const PROGRAM_INFO = 'PROGRAM_INFO';

//language detection
export const LANGUAGE = 'LANGUAGE';

//get Playlist
export const PLAYLIST = 'PLAYLIST';

// sub info check
export const SUB_INFO = 'SUB_INFO';

// sign up
export const SIGN_UP = 'SIGN_UP';

//otp
export const SEND_OTP = 'SEND_OTP';

//opt verify
export const OTP_VERIFY = 'OTP_VERIFY';
